// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__2a4Ez","editor":"TextArea_editor__T5zvj"};